// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck - we need to disable this rule because the diff function is not typed
const extendedTypeOf = (obj) => {
    const result = typeof obj;
    if (obj == null) {
        return 'null';
    }
    if (result === 'object' && obj.constructor === Array) {
        return 'array';
    }
    if (result === 'object' && obj instanceof Date) {
        return 'date';
    }
    return result;
};

const roundObj = (data, precision) => {
    const type = typeof data;
    if (type === 'array') {
        return data.map((x) => roundObj(x, precision));
    }
    if (type === 'object') {
        for (const key in data) {
            data[key] = roundObj(data[key], precision);
        }
        return data;
    }
    if (type === 'number' && Number.isFinite(data) && !Number.isInteger(data)) {
        return +data.toFixed(precision);
    }
    return data;
};

export { extendedTypeOf, roundObj };
